import * as React from 'react';
import { SVGProps } from 'react';

const SvgGetQuote = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 140 80'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      stroke='#0F2EFF'
      strokeWidth={5}
      strokeLinecap='round'
      d='M3.5 18.433h49.002'
    />
    <path
      d='M121.503 4.624h14.489M4.624 4.624h14.488'
      stroke='#909090'
      strokeWidth={8}
      strokeLinecap='round'
    />
    <path
      d='M122.829 20.027H136'
      stroke='#909090'
      strokeWidth={5}
      strokeLinecap='round'
    />
    <path
      stroke='#909090'
      strokeWidth={4}
      strokeLinecap='round'
      d='M128.78 31.785H134'
    />
    <path
      d='M101.755 32.798h19.757M3 31.785h7.854'
      stroke='#ECECEC'
      strokeWidth={4}
      strokeLinecap='round'
    />
    <path
      stroke='#FED119'
      strokeWidth={2.907}
      strokeLinecap='round'
      d='M2.454 46.82h20.8'
    />
    <path
      stroke='#ECECEC'
      strokeWidth={2.907}
      strokeLinecap='round'
      d='M2.454 52.088h3.678M11.674 52.088h3.678'
    />
    <path
      stroke='#909090'
      strokeWidth={4}
      strokeLinecap='round'
      d='M17.488 31.785h15.757'
    />
    <path
      d='M92.535 20.027h25.025'
      stroke='#ECECEC'
      strokeWidth={5}
      strokeLinecap='round'
    />
    <rect
      x={43.802}
      y={57.174}
      width={92.198}
      height={22.391}
      rx={11.195}
      fill='#0F2EFF'
    />
    <path
      d='M112.324 67.967c3.669-.111 11.009 0 11.009 0m0 0-4.262-4m4.262 4-4.262 3.999'
      stroke='#fff'
      strokeWidth={1.454}
    />
    <path
      d='M61.39 70.118h2.607c-.2 1.17-.674 2.155-1.422 2.956-.833.895-2.029 1.343-3.588 1.343-1.296 0-2.392-.369-3.288-1.106-.885-.748-1.464-1.776-1.738-3.082h-1.407v-1.186h1.249a5.237 5.237 0 0 1-.016-.537c0-.327.005-.537.016-.632h-1.249v-1.201h1.423c.295-1.276.88-2.271 1.754-2.988.875-.716 1.96-1.075 3.256-1.075 1.538 0 2.724.443 3.556 1.328a5.736 5.736 0 0 1 1.438 2.86h-2.64c-.336-1.285-1.127-1.927-2.37-1.927-1.18 0-1.939.6-2.276 1.802h2.64v1.2H56.49a6.61 6.61 0 0 0-.016.601c0 .295.005.485.016.57h2.845v1.185h-2.672c.348 1.285 1.123 1.928 2.324 1.928 1.296 0 2.097-.68 2.402-2.039Z'
      fill='#fff'
    />
    <path
      d='M110.595 6.025h1.746c-.134.783-.452 1.442-.952 1.978-.558.6-1.358.9-2.402.9-.867 0-1.601-.247-2.2-.74-.593-.502-.981-1.19-1.164-2.064h-.942v-.793h.836c-.007-.05-.01-.17-.01-.36 0-.219.003-.36.01-.423h-.836v-.804h.952c.198-.854.589-1.52 1.175-2 .585-.48 1.312-.719 2.179-.719 1.03 0 1.823.296 2.38.889.501.543.822 1.181.963 1.915h-1.767c-.225-.86-.754-1.291-1.587-1.291-.789 0-1.297.402-1.523 1.206h1.767v.804h-1.904a4.04 4.04 0 0 0-.011.402c0 .197.003.324.011.38h1.904V6.1h-1.788c.233.86.751 1.29 1.555 1.29.868 0 1.404-.454 1.608-1.364Z'
      fill='#909090'
    />
  </svg>
);

export default SvgGetQuote;
